<template>
  <div id="main">
    <Navigation :key="update" />

    <v-main>
      <router-view
        @updateProfileImage="updateProfile"
        @show="showSuccessAlert"
      />
    </v-main>

    <v-scale-transition>
      <v-alert
        v-show="showSuccess"
        elevation="9"
        type="success"
        class="successAlert"
      >
        {{ message }}
      </v-alert>
    </v-scale-transition>
  </div>
</template>

<style scoped>
#main {
  max-width: unset;

  width: 100%;
  height: 100%;
}

.successAlert {
  z-index: 100;
  position: absolute;
  right: 2%;
  top: 10%;
  white-space: nowrap;
}

@media (max-width: 400px) {
  .successAlert {
    position: absolute;
    right: 7%;
    left: 7%;
  }
}
</style>

<script>
import Navigation from "./Navigation";

export default {
  name: "Authenticated",

  data: () => ({
    showSuccess: false,
    update: false,
    message: "",
  }),

  components: {
    Navigation,
  },

  methods: {
    updateProfile() {
      this.update = !this.update;
    },

    showSuccessAlert(message) {
      this.message = message;

      this.showSuccess = true;

      setTimeout(() => {
        this.showSuccess = false;
      }, 4500);
    },
  },
};
</script>
